import MontserratRegular from './Montserrat-Regular.ttf';
import MontserratBlack from './Montserrat-Black.ttf';
import MontserratBold from './Montserrat-Bold.ttf';

export default {
  MontserratRegular,
  MontserratBold,
  MontserratBlack,
};
